<template>
	<div>
		<b-row>
			<b-col md="12" class="mb-4">
				<h6>Null</h6>
				<multi-text v-model="value1"/>
				<span>{{ value1 }}</span>
			</b-col>
			<b-col md="12" class="mb-4">
				<h6>Single Selected</h6>
				<multi-text v-model="value2"/>
				<span>{{ value2 }}</span>
			</b-col>
			<b-col md="12" class="mb-4">
				<h6>Validate Error</h6>
				<multi-text v-model="value3" :validate-error="value3ValidateError"/>
				<span>{{ value3 }}</span>
			</b-col>
			<b-col md="12" class="mb-4">
				<h6>Height</h6>
				<multi-text v-model="value4" :height="'400px'"/>
				<span>{{ value4 }}</span>
			</b-col>
			<b-col cols="12">
				<b-button variant="primary" @click="change()">
					{{ $t('change').toUpper() }}
				</b-button>
			</b-col>
		</b-row>
	</div>
</template>
<script>
	import MultiText from "@/components/interactive-fields/MultiText";

	export default {
		components: {
			MultiText,
		},
		data() {
			return {
				value1: null,
				value2: 'ubit,ubit1,ubit2',
				value3: 'ubit,ubit1,ubit2',
				value4: 'ubit,ubit1,ubit2',
				value3ValidateError: 'Validate Error is Working',
			}
		},
		methods: {
			change() {
				this.value2 = 'bahcesehir, universitesi'
				this.value3 = 'bahcesehir, universitesi'
				this.value3ValidateError = 'Error'
				this.value4 = 'bahcesehir, universitesi'
			}
		}
	};
</script>

